module.exports = __webpack_public_path__ + "img/full4-min.fdb8fde9.png";